export default __webpack_public_path__ + "static/media/depot-white.c396991d.svg";